import { TextProps } from '../../components'

export const daysIconProps: TextProps = {
  text: 'days',
  tx: 'label.days',
  color: 'border'
}
